export default "__VITE_PUBLIC_ASSET__79e3cc2a__"